import { type ComponentProps, useMemo } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Button from "@/v2-backoffice-client/components/button"
import { useTableContext } from "./table.context"

export type TableColumnButtonProps = ComponentProps<"button">

/**
 * Column visibility toggle button. Opens the inline columns panel below the toolbar.
 */
function TableColumnButton(props: TableColumnButtonProps) {
  const { className, onClick, ...buttonProps } = props
  const { table, activePanel, setActivePanel } = useTableContext()

  const cols = useMemo(() => {
    return table.getAllColumns().filter((c) => {
      if (c.id === "__select") return false
      return c.getCanHide()
    })
  }, [table])

  if (cols.length === 0) return null

  const isActive = activePanel === "columns"

  return (
    <Button
      variant={isActive ? "secondary" : "ghost"}
      size="xs"
      iconSrc="columns-3"
      iconClassName="ui-table-icon"
      className={cn("ui-table-column-selector-button", className)}
      onClick={(e) => {
        setActivePanel(isActive ? null : "columns")
        onClick?.(e)
      }}
      {...buttonProps}
    >
      Columns
    </Button>
  )
}

export default TableColumnButton
